import React from 'react';
import { Link } from 'react-router-dom';
import { recordsData } from '../mockData';
import { ExternalLink } from 'lucide-react';

const Records = () => {
  const recordTypes = [
    { key: 'guinness', name: 'Guinness World Records', path: '/records/guinness', Image: '/records/logos/guinness-logo.png' },
    { key: 'worldBook', name: 'World Book of Records', path: '/records/world-book',Image: '/records/logos/world-book-logo.png' },
    { key: 'indiaBook', name: 'India Book of Records', path: '/records/india-book',Image: '/records/logos/india-book-logo.png' },
    { key: 'asiaBook', name: 'Asia Book of Records', path: '/records/asia-book',Image: '/records/logos/asia-book-logo.png' },
  ];

  return (
    <div style={{ backgroundColor: 'var(--bg-page)', minHeight: '100vh', padding: '80px 0' }}>
      <div className="container-custom">
        <h1 className="heading-1" style={{ marginBottom: '24px', textAlign: 'center' }}>WORLD RECORDS</h1>
        <p className="body-medium" style={{ textAlign: 'center', marginBottom: '60px', maxWidth: '800px', margin: '0 auto 60px' }}>
          ESN Publications has achieved remarkable milestones in academic publishing, earning recognition from prestigious record-keeping organizations worldwide.
        </p>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '32px', maxWidth: '1200px', margin: '0 auto' }}>
          {recordTypes.map((recordType) => (
            <Link
              key={recordType.key}
              to={recordType.path}
              style={{
                textDecoration: 'none',
                backgroundColor: 'var(--bg-card)',
                border: '1px solid var(--border-medium)',
                borderRadius: '12px',
                padding: '30px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'space-between',
                height: '350px',
                transition: 'all 0.3s ease',
                cursor: 'pointer',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-8px)';
                e.currentTarget.style.backgroundColor = 'var(--border-medium)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.backgroundColor = 'var(--bg-card)';
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '120px', marginBottom: '20px' }}>
                <img
                  src={recordsData[recordType.key].logo}
                  alt={recordType.name}
                  style={{ maxWidth: '200px', maxHeight: '100px', objectFit: 'contain' }}
                />
              </div>
              <div style={{ textAlign: 'center', flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                <h3 className="heading-3" style={{ marginBottom: '20px', fontSize: '1.1rem', lineHeight: '1.3' }}>
                  {recordType.name}
                </h3>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', color: 'var(--brand-primary)', fontSize: '0.9rem', fontWeight: 600 }}>
                  <span>VIEW RECORDS</span>
                  <ExternalLink size={16} />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Records;